import React, {useState, useEffect} from "react"
import { toast } from "react-toastify";
import { store } from "../../redux/oldStore";
import { ServerResponse } from "../../utils/Server";
import { ProjectDetails2 } from "./projectDetails2";
import {
  ICustomQuestions,
  IProject,
  IShowcaseSettings,
  ITopEntryPick,
  ISetTopEntryResult,
  nextOpenTopRank,
  topRankByProjectId,
} from "./ShowcaseTypes";
import { useParams } from "react-router-dom";
import Modal from "../Modal/Modal";

interface IProjectDetailsWraperProps {
    ProjectKey?:string;
}

interface IProjectShowcaseData{
    projectCustomQuestions: ICustomQuestions[];
    settings: IShowcaseSettings;
    project: IProject;    
    myLikes: any;
    likes:any;
    myTopEntries?: ITopEntryPick[];
    topEntryCounts?: { [projectId: string]: number };
}

const ProjectDetailsWraper = (props:IProjectDetailsWraperProps) =>{
  const {projectKey} = useParams();
    const [data, setData] = useState<IProjectShowcaseData>();
    const [projectLikesDic, setProjectLikesDic] = useState<any>({});
    const [myLikesDic, setMyLikesDic] = useState<any>({});
    const [myTopEntries, setMyTopEntries] = useState<ITopEntryPick[]>([]);
    const [topEntryCounts, setTopEntryCounts] = useState<{ [projectId: string]: number }>({});
    const [replaceTopModalOpen, setReplaceTopModalOpen] = useState<boolean>(false);

    useEffect(()=>{
        LoadData(props.ProjectKey ?? projectKey ?? '');
    }, []);

    const LoadData = (key:string)=>{
        store.server.postApi<ServerResponse<IProjectShowcaseData>>('../Showcase/ProjectData', {projectKey:key})
        .then(x=>{
            if(x.Success){
                setData(x.Value);
                setProjectLikesDic(x.Value.likes);
                let myLikes = {};
                if (x.Value.myLikes) {
                  x.Value.myLikes.forEach((x) => {
                    myLikes[x] = "true";
                  });
                }
                setMyLikesDic(myLikes);
                setMyTopEntries(x.Value.myTopEntries || []);
                setTopEntryCounts(x.Value.topEntryCounts || {});
            } else {
                toast.error(x.Message, {autoClose:false});
            }
        });
    };

    
  const likeProject = (projectId: number, like: boolean) => {
    const request = { projectId, like };
    store.server.postApi("../showcase/LikeProject", request).then((x: any) => {
      if (x.Success) {
        let dic = projectLikesDic;
        let cv = dic[projectId] || 0;
        if (like) cv++;
        else cv--;

        dic[projectId] = cv;
        setProjectLikesDic(dic);

        let myLikes = myLikesDic;
        myLikes[projectId] = like;
        setMyLikesDic(myLikes);
      }
    });
  };

  const saveTopEntry = (projectId: number, rank: number, selected: boolean) => {
    store.server
      .postApi<ServerResponse<ISetTopEntryResult>>("../showcase/SetTopEntry", {
        projectId,
        rank,
        selected,
      })
      .then((x) => {
        if (x.Success) {
          setMyTopEntries(x.Value.myTopEntries || []);
          if (x.Value.topEntryCounts) setTopEntryCounts(x.Value.topEntryCounts);
          setReplaceTopModalOpen(false);
        } else {
          toast.error(x.Message, { autoClose: false });
        }
      });
  };

  const handleTopEntryClick = (projectId: number) => {
    if (!data?.settings?.canSelectTopEntries) return;
    const max = data.settings.topEntriesMax || 3;
    const existing = myTopEntries.find((p) => p.ProjectId === projectId);
    if (existing) {
      saveTopEntry(projectId, existing.Rank, false);
      return;
    }
    const next = nextOpenTopRank(myTopEntries, max);
    if (next != null) {
      saveTopEntry(projectId, next, true);
      return;
    }
    setReplaceTopModalOpen(true);
  };

  const handleTopEntryRank = (projectId: number, rank: number) => {
    if (!data?.settings?.canSelectTopEntries) return;
    saveTopEntry(projectId, rank, true);
  };

    return (
        <div className="showcase-project-container">
            {!data && <>loading...</>}
            {data && <>
                <ProjectDetails2 
                    project={data.project}
                    settings={data.settings}
                    projectQuestions={data.projectCustomQuestions} 
                    likes={projectLikesDic[data.project.projectIntId] || 0}
                    myLikes={myLikesDic}
                    likeProject={likeProject}
                    myTopRank={topRankByProjectId(myTopEntries)[data.project.projectIntId]}
                    topEntryCount={topEntryCounts[data.project.projectIntId] || 0}
                    onTopEntryClick={handleTopEntryClick}
                    onPickTopRank={handleTopEntryRank}
                                   />
            </>}
            {replaceTopModalOpen && data && (
              <Modal
                setModalOpen={setReplaceTopModalOpen}
                title="Replace a top entry"
              >
                <div className="top-entry-replace">
                  <p>
                    You already selected {data.settings.topEntriesMax || 3} top entries.
                    Choose which one <strong>{data.project.title}</strong> should replace.
                  </p>
                  <div className="top-entry-replace-list">
                    {myTopEntries
                      .slice()
                      .sort((a, b) => a.Rank - b.Rank)
                      .map((pick) => (
                        <button
                          key={pick.ProjectId}
                          type="button"
                          className="btn btn-default top-entry-replace-item"
                          onClick={() => saveTopEntry(data.project.projectIntId, pick.Rank, true)}
                        >
                          <span className="top-entry-replace-rank">#{pick.Rank}</span>
                          <span>
                            {pick.ProjectCode ? `${pick.ProjectCode} ` : ""}
                            {pick.Title}
                          </span>
                        </button>
                      ))}
                  </div>
                </div>
              </Modal>
            )}

        </div>
    );
}

export default ProjectDetailsWraper;